import React from 'react';
import ButtonExternal from 'components/Buttons/ExternalLink';
import { BoltIcon as LightningBolt } from '@heroicons/react/24/outline';
import tw from 'twin.macro';
import H1 from 'components/Typography/Headings/H1';
import { useTranslation } from 'react-i18next';

interface Props {
  hideOnMobile?: boolean;
  title?: any;
  utmCampaign: string;
}

export function TryTeetshHeader(props: Props) {
  const { hideOnMobile, utmCampaign, title } = props;
  const { t } = useTranslation(['common']);
  return (
    <header
      css={[
        tw` dark:bg-neutral-intense dark:text-white`,
        hideOnMobile && tw`hidden md:block`,
      ]}
    >
      <nav
        tw="mx-auto flex items-center justify-between py-3 lg:px-8 flex-col md:flex-row"
        aria-label="Global"
      >
        <div tw="flex flex-1"></div>
        <div tw="text-center">{title && <H1 tw="text-center">{title}</H1>}</div>
        <div tw="flex flex-1 justify-end">
          <ButtonExternal
            large
            href={`https://teetsh.com/?utm_source=teetsh&utm_campaign=${utmCampaign}&utm_content=try_teetsh`}
            target="_self"
            minimal
            tw="dark:text-white dark:hover:text-brand-intense"
          >
            <span>
              <LightningBolt tw="inline-block h-5 w-5 text-yellow-500! mr-2" />
              {t('common:tryTeetsh')}
            </span>
          </ButtonExternal>
        </div>
      </nav>
    </header>
  );
}
